import type { TemplateStructure } from "../types";

/**
 * 1. Faculty Linear Structure
 * Authoritative, chronological layout with publication priority,
 * standard hero, and sticky-minimal navigation.
 */
export const facultyLinearStructure: TemplateStructure = {
  id: "faculty-linear",
  name: "Faculty Linear",
  themeKey: "classic-academic",
  layoutModel: "linear",
  heroLayout: "standard",
  navigationStyle: "sticky-minimal",
  cardGeometry: "sharp",
  supportedSections: [
    "about",
    "publications",
    "teaching",
    "experience",
    "awards",
    "contact",
  ],
  defaultContainerWidth: "normal",
  heroOverrides: {
    avatarShape: "circle",
    avatarSize: "xl",
    avatarPosition: "center",
    nameAlign: "center",
  },
};

/**
 * 2. Bento Grid Structure
 * Asymmetric bento identity block with modular cards,
 * high scannability, and modern-bento renderer.
 */
export const bentoGridStructure: TemplateStructure = {
  id: "bento-grid",
  name: "Bento Modular Grid",
  themeKey: "modern-bento",
  layoutModel: "bento",
  heroLayout: "card",
  navigationStyle: "sticky-minimal",
  cardGeometry: "bento-grid",
  supportedSections: [
    "about",
    "publications",
    "projects",
    "skills",
    "teaching",
    "contact",
  ],
  defaultContainerWidth: "wide",
  heroOverrides: {
    avatarShape: "squircle",
    avatarSize: "lg",
    avatarPosition: "left",
    nameAlign: "left",
  },
};

/**
 * 3. Showcase Portfolio Structure
 * Visual showcase with figure cards, project galleries,
 * and grid-showcase renderer.
 */
export const showcasePortfolioStructure: TemplateStructure = {
  id: "showcase-portfolio",
  name: "Showcase Grid Portfolio",
  themeKey: "grid-showcase",
  layoutModel: "showcase",
  heroLayout: "split-left",
  navigationStyle: "full-header",
  cardGeometry: "rounded-md",
  supportedSections: [
    "about",
    "projects",
    "publications",
    "gallery",
    "experience",
    "contact",
  ],
  defaultContainerWidth: "wide",
  heroOverrides: {
    avatarShape: "rounded",
    avatarSize: "2xl",
    avatarPosition: "left",
    nameAlign: "left",
  },
};

/**
 * 4. Editorial Split Structure
 * Asymmetric split-column hero with long-form monograph reading,
 * high typography contrast, and minimalist-scholar renderer.
 */
export const editorialSplitStructure: TemplateStructure = {
  id: "editorial-split",
  name: "Editorial Split Column",
  themeKey: "minimalist-scholar",
  layoutModel: "editorial",
  heroLayout: "split-right",
  navigationStyle: "split-nav",
  cardGeometry: "sharp",
  supportedSections: [
    "about",
    "publications",
    "experience",
    "awards",
    "contact",
  ],
  defaultContainerWidth: "normal",
  heroOverrides: {
    avatarShape: "square",
    avatarSize: "xl",
    avatarPosition: "right",
    nameAlign: "left",
  },
};

export const ALL_STRUCTURES: TemplateStructure[] = [
  facultyLinearStructure,
  bentoGridStructure,
  showcasePortfolioStructure,
  editorialSplitStructure,
];
